import { useCallback, useEffect, useState } from 'react';

import { listarHistoricoCustosProduto } from '../../../../../../../api/movimento';

export default function useHistoricoCustosProduto({
    empresaId,
    produtoId,
    limite = 10,
    movimentoIdIgnorar,
    movimentoItemIdIgnorar,
    carregarAutomaticamente = true,
}) {
    const [historico, setHistorico] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const carregar = useCallback(async () => {
        if (!empresaId || !produtoId) {
            setHistorico([]);
            setError('');
            return [];
        }

        setLoading(true);
        setError('');

        try {
            const resultado = await listarHistoricoCustosProduto({
                empresaId,
                produtoId,
                limite,
                movimentoIdIgnorar,
                movimentoItemIdIgnorar,
            });

            if (resultado?.error) {
                const mensagem = resultado.error.message || 'Não foi possível carregar o histórico de custos.';

                setError(mensagem);
                setHistorico([]);

                return [];
            }

            const lista = Array.isArray(resultado?.historico) ? resultado.historico : [];

            setHistorico(lista);

            return lista;
        } catch (error) {
            console.error('Erro ao carregar histórico de custos do produto:', error);

            const mensagem =
                error?.response?.data?.message ||
                error?.response?.data?.messages ||
                'Erro ao carregar o histórico de custos do produto.';

            setError(mensagem);
            setHistorico([]);

            return [];
        } finally {
            setLoading(false);
        }
    }, [empresaId, produtoId, limite, movimentoIdIgnorar, movimentoItemIdIgnorar]);

    useEffect(() => {
        if (!carregarAutomaticamente) return;

        carregar();
    }, [carregarAutomaticamente, carregar]);

    return {
        historico,
        loading,
        error,
        carregar,
    };
}
